module.exports = __webpack_public_path__ + "img/finance.b5c74cd5.svg";